import Axios from "axios";
import { error } from "jquery";
import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CheckUserLogin = () => {
  //   const navigate = useNavigate();
  const history = useHistory();

  useEffect(() => {
    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=ACCOUNTTYPE",
      { withCredentials: true }
    )
      .then((response) => {
        if (response.data.account_type === "guest") {
          localStorage.clear();
          history.push("/login");
        }
      })
      .catch((error) => {
        console.error("Session check failed:", error);
        // Optionally: log out if there's an error
        localStorage.clear();
      });
    const businessid = localStorage.getItem("businessid");
    const partnerid = localStorage.getItem("partnerid");
    const customerid = localStorage.getItem("customerid");

    if (!businessid && !partnerid && !customerid) {
      //   navigate("/login");
      history.push("/login");
    }
  }, []);

  return null; // No UI, just redirect logic
};
export { CheckUserLogin };
